import { useEffect } from "react";
import authStorage from "../utils/authStorage";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../config";

const ImpersonateLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const impersonate = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const userId = params.get("userId");

        if (!userId) {
          navigate("/");
          return;
        }

        const adminToken =
          sessionStorage.getItem("auth-token") ||
          authStorage.getItem("auth-token");

        const res = await axios({
          url: `${BASE_URL}/auth/impersonate/${userId}`,
          method: "POST",
          headers: {
            "x-access-token": adminToken, // ADMIN TOKEN
          },
        });

        const data = res?.data?.data;

        //alert(data?.email);

        if (!data?.accessToken) {
          throw new Error("Impersonation failed");
        }

        /* ===============================
           STORE IMPERSONATION DATA (TAB ONLY)
        =============================== */

        sessionStorage.setItem("auth-token", data.accessToken);
        sessionStorage.setItem(
          "walkthrough",
          JSON.stringify({
              walkThroughPending: data?.walkThroughPending ?? false, // or appropriate default
              walkThroughSteps: data?.walkThroughSteps ?? [] // or appropriate default
          })
        );
        sessionStorage.setItem(
          "company",
          JSON.stringify(JSON.stringify(data?.company ?? {}))
        );
        sessionStorage.setItem(
          "user",
          JSON.stringify({
              price: data?.price ?? 0, // or null, depending on your needs
              userCount: data?.userCount ?? 0,
              userRange: data?.userRange ?? [],
              expectedCftUser: data?.expectedCftUser ?? 0
          })
        );
        sessionStorage.setItem("roles", data?.roles);
        sessionStorage.setItem(
          "user-name",
          `${data?.firstName || data?.company?.companyName || ""} ${data?.lastName || ""}`
        );
        sessionStorage.setItem("email", data?.email);
        sessionStorage.setItem("userId", data?._id);
        sessionStorage.setItem(
          "subscribedStatus",
          data?.subscribedStatus || false
        );
        sessionStorage.setItem("planType", data?.planType || "");
        sessionStorage.setItem("coupon", data?.coupon || "");
        sessionStorage.setItem("status", data?.status || "");

        /* ===============================
           REDIRECT AS IMPERSONATED USER
        =============================== */

        navigate("/dashboard");
      } catch (err) {
        console.error(err);
        alert("Failed to impersonate user");
        navigate("/");
      }
    };

    impersonate();
  }, [navigate]);

  return <p>Logging in as user...</p>;
};

export default ImpersonateLogin;
